<template>
  <v-menu offset-y
          rounded="lg"
          v-model="isOpen">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
      >
        <bell-icon size="1.5x" class="grey--text"></bell-icon>
        <v-badge
          bordered
          :content="countUnreads"
          v-if="countUnreads"
        />
      </v-btn>
    </template>
    
    <!-- notifications -->
    <v-list max-height="30vh"
            class="overflow-y-auto">
      
      <!-- notification -->
      <v-list-item
        v-for="(notification, index) in notifications"
        :key="index"
        :class="{ 'blue lighten-5':!notification.isRead }"
        @click="onClick(notification)"
      >
        <v-list-item-icon class="mr-3">
          <v-icon :color="notification.isRead ? '':'primary lighten-1'">
            {{ notification.icon || defaultIcon }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-html="notification.message"/>
          <v-list-item-subtitle>
            <div v-html="notification.subtitle"></div>
            <!-- @todo buttons -->
            <!--
            <p class="mt-3">
              <v-btn small depressed>
                Clicca qui
              </v-btn>
            </p>
            -->
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      
      <!-- no notifications? -->
      <v-list-item v-if="!hasNotifications">
        <v-alert class="mb-0" dense>
          Non ci sono notifiche
        </v-alert>
      </v-list-item>

    </v-list>
  </v-menu>
</template>

<script>
  import _ from 'lodash'

  import { mapActions } from 'vuex'

  import API from '@/api'

  import utility from '@/mixins/utility'

  import { BellIcon } from 'vue-feather-icons'

   export default {
    
    name: 'UserNotifications',

    mixins: [ utility ],

    components:
    {
      BellIcon,
    },

    data: () => ({
      defaultIcon: '', // tbd
      isOpen: false,
      notifications: []
    }),

    computed:
    {
      countUnreads()
      {
        return _.filter(this.notifications, (notification)=>{
          return !notification.isRead
        }).length
      },

      hasNotifications()
      {
        return this.notifications.length > 0
      }
    },

    methods:
    {
      ...mapActions({
        route: 'menu/route'
      }),

      load()
      {
        API.user.notifications()
                .then(({ data })=>{
                  this.notifications = this.mapModels(data.data, 'notification')
                })
      },

      markAllRead()
      {
        const notificationsId = this.notifications.map((n)=>n.id)

        API.user.markNotifications(notificationsId)
                .then(this.load())
      },

      onClick(notification)
      {
        if(notification.cta)
          this.route(notification.cta)
      }
    },

    watch:
    {
      isOpen(isOpen)
      {
        // quando chiudo il menu segno tutte le notifiche come lette
        if(!isOpen && this.countUnreads)
          this.markAllRead()
      }
    },

    mounted()
    {
      this.load()
    }
  }
</script>